import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

const config = {
    projectId: 'conectae-imgs',
    appId: '1:1057240317825:web:60171d1bb9bd6857617280',
    storageBucket: 'conectae-imgs.appspot.com',
    locationId: 'us-central',
    apiKey: 'AIzaSyDMjZyn5upV2ldq6UV0sKYbq9A1R8qm6uU',
    authDomain: 'conectae-imgs.firebaseapp.com',
    messagingSenderId: '1057240317825'
}

const app = initializeApp(config)
const db = getFirestore(app)
const storage = getStorage(app)

export { storage, db }
